import React from 'react';
import PropTypes from 'prop-types';
export var Component = function Component(_ref) {
  var imageSrc = _ref.imageSrc,
      style = _ref.style;
  return React.createElement("img", {
    src: imageSrc,
    style: style
  });
};
Component.displayName = 'GoogleMapMarker';
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  imageSrc: PropTypes.string.isRequired,
  style: PropTypes.shape({
    transform: PropTypes.string.isRequired
  }).isRequired
} : {};